export default __webpack_public_path__ + "static/media/expl-nn_08_DE.cd91b1bb.png";